import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigation } from "@react-navigation/native";

import { BackLogin, Container, Content, Image, Text } from "./styles";
import { TextFieldLogin, Button, BottomSheet, Header } from "../../components";
import { TextInput } from "react-native-paper";
import { api } from "../../api/api";
import { Modalize } from "react-native-modalize";
import UserContext from "../../context/user";
import ClientContext from "../../context/client";
import RegisterDriverContext from "../../context/registerDriver";
import RouteContext from "../../context/route";

const RecoveryPassword = () => {
  const navigation = useNavigation();
  const bottomSheetErrorRef = useRef<Modalize>(null);
  const { recoveryPassword } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  
  const [email, setEmail] = useState('');

  async function handleRecoveryPassword() {
    setLoading(true);
    const data = { email };
    try {
      await recoveryPassword(data);
      setLoading(false);
      navigation.goBack();
    } catch (err) {
      console.log(err);
      bottomSheetErrorRef.current?.open();
      setLoading(false);
    }
  }

  return (
    <Container>
      <Content>
        <Image source={require("../../assets/images/logo.png")} />
        <TextFieldLogin label="E-mail" placeholder="E-mail" value={email} onChangeText={(text: string) => setEmail(text)} />
        <Button title="Redefinir" loading={loading} onPress={handleRecoveryPassword} />
        <BackLogin onPress={() => navigation.goBack()}>
          <Text>Voltar ao login</Text>
        </BackLogin>
      </Content>
      <BottomSheet
          bottomSheetRef={bottomSheetErrorRef}
          title="Não foi possível verificar o e-mail"
          description="Verifique seus dados e tente de novamente."
          textButton="Entendi"
          typeButton="filled"
          accessibilityHintButton="Entendi"
          onClose={() => bottomSheetErrorRef.current?.close()}
          onPress={() => bottomSheetErrorRef.current?.close()}
        />
    </Container>
  );
};

export default RecoveryPassword;
